module.exports = __webpack_public_path__ + "img/join.06524ad7.png";